export const TILE_HEIGHT = 294;
export const TILE_WIDTH = 266;

export const SVG_PROPS = {
  width: TILE_WIDTH,
  height: TILE_HEIGHT,
  viewBox: `0 0 ${TILE_WIDTH} ${TILE_HEIGHT}`,
};
